/* Reel feed */
const reelsContainer = document.querySelector("#reels-container");
const reels = document.querySelectorAll(".reel-video");
const reelsVideoContainer = document.querySelectorAll(".reel");
const reelsVideoMainContainer = document.querySelector(".reelVideoContainer");
const btn = document.querySelector(".mute-btn");
const btnMuted = document.querySelector("#muteButton");
const btnSound = document.querySelector("#soundButton");
const closeReels = document.querySelector("#closeReels");

/* Reel carousel */
const reelsCarouselContainer = document.querySelector(".reelGallery");
const reelsCarousel = document.querySelectorAll(".galleryReel");

let currentCarouselIndex = 0;
let interval;

/* Reel feed */
let isMuted = true;

reelsCarousel.forEach((video, i) => {
  video.addEventListener("click", () => {
    reelsVideoMainContainer.prepend(reelsVideoContainer[i]);
    reelsVideoMainContainer.children[i].remove()
    reelsContainer.style.display = "flex";
  });
});

closeReels.addEventListener("click", () => {
  reelsContainer.style.display = "none";
  reelsVideoMainContainer.replaceChildren(...reelsVideoContainer)
});

const playVideo = (index) => {
  reels.forEach((video, i) => {
    if (i === index) {
      video.play();
    } else {
      video.pause();
    }
  });
};

// Intersection Observer per gestire autoplay e pause
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      const video = entry.target;

      if (entry.isIntersecting) {
        video.play();
      } else {
        video.pause();
      }
    });
  },
  { threshold: 0.5 } // Attiva quando almeno il 50% del video è visibile
);

// Applica l'Observer a ogni video
reels.forEach((video) => observer.observe(video));

// Tap to pause/play
reels.forEach((video) => {
  video.addEventListener("click", () => {
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  });
});

btn.addEventListener("click", () => {
  isMuted = !isMuted;
  reels.forEach((video) => {
    video.muted = isMuted;
  });
  if (isMuted) {
    btnSound.style.display = "none";
    btnMuted.style.display = "block";
  } else {
    btnMuted.style.display = "none";
    btnSound.style.display = "block";
  }
});

// Share button
/* document.querySelectorAll(".share-btn").forEach((btn, i) => {
  btn.addEventListener("click", () => {
    const url = reels[i].getAttribute("src");
    navigator.clipboard.writeText(url);
    alert("Link copiato negli appunti!");
  });
}); */

/* Reel carousel */
function playNextVideo() {
  if (reelsCarousel.length === 0) return;

  // Stop tutti i video
  reelsCarousel.forEach((video) => video.pause());

  // Riproduci il video attuale
  const currentVideo = reelsCarousel[currentCarouselIndex];
  currentVideo.currentTime = 0; // Riavvia il video
  currentVideo.play();

  // Dopo 3 secondi, passa al prossimo video
  interval = setTimeout(() => {
    currentCarouselIndex++;

    // Se siamo oltre l'ultimo video, passa alla prossima slide
    if (currentCarouselIndex % 4 === 0) {
      // Sposta il carosello alla slide successiva
      scrollToNextSlide();
    }

    if(currentCarouselIndex >= reelsCarousel.length) {
       currentCarouselIndex = 0;
      scrollReset();
    }

    playNextVideo();
  }, 3000);
}

function scrollReset () {  
  reelsCarouselContainer.scrollBy({
    left: -reelsCarouselContainer.clientWidth,
    behavior: "smooth",
  });
}

function scrollToNextSlide() {
  const videoWidth = reelsCarousel[0].clientWidth; // Larghezza di un video

  // Calcola di quanto deve scorrere (4 video alla volta)
  const scrollAmount = videoWidth * 4;

  // Esegui lo scroll orizzontale
  reelsCarouselContainer.scrollBy({
    left: scrollAmount,
    behavior: "smooth",
  });
}


// Avvia la sequenza
playNextVideo();
